import { defaultTo } from 'ramda';
import { IRecommendedServicePackageV2 } from '../../../../../repositories/billing-tariffs/entities/PublishTerms/RecommendedServicePackageV2';
import { ERecommendedPackageType, IRecommendedPackage } from '../../../../../types/reducers/recommendedPackages';
import { mapPackageService } from './mapPackageService';
import uniqueId from 'lodash/uniqueId';
import { mapGift } from './mapGift';
import {
  ECustomPackageDealType,
  ECustomPackageOfferType,
  EPackageType,
} from '../../../../../../PayPackageMicrofrontend';
import { mapWidgetSource } from './mapWidgetSource';
import { formatLongDate } from '../../../../../utils/date';

export const mapRecommendedPackage = (recommendedPackage: IRecommendedServicePackageV2): IRecommendedPackage => {
  const {
    id,
    headerText,
    tooltipText,
    durationInDays,
    regionNames,
    categoriesView,
    price,
    discountPercent,
    marketingPrice,
    announcementPrice,
    packageStartDate,
    packageEndDate,
    totalAnnouncementsCount,
    totalAuctionPointsCount,
    services,
    polygonIds,
    dealType,
    offerTypes,
    packageType,
    isAutoProlong,
    isAutoProlongAvailable,
  } = recommendedPackage;

  const gifts = defaultTo([], recommendedPackage.gifts);
  const type = recommendedPackage.type as string as EPackageType;

  return {
    id: uniqueId(),
    packageId: id,
    autoProlong: Boolean(isAutoProlong),
    autoProlongAvailable: Boolean(isAutoProlongAvailable),
    headerText: defaultTo('', headerText),
    tooltipText: defaultTo('', tooltipText),
    durationInDays,
    regionNames,
    categoriesView,
    price,
    discountPercent,
    marketingPrice,
    pricePerOffer: announcementPrice,
    activationDate: formatLongDate(packageStartDate),
    endDate: formatLongDate(packageEndDate),
    totalPublicationCount: totalAnnouncementsCount,
    totalAuctionPoints: totalAuctionPointsCount,
    selected: false,
    services: services.map(mapPackageService),
    type,
    polygonIds,
    dealType: dealType as string as ECustomPackageDealType,
    offerTypes: offerTypes as string[] as ECustomPackageOfferType[],
    packageType: packageType as string as ERecommendedPackageType,
    gifts: gifts.map(mapGift),
    widgetSource: mapWidgetSource(type),
  };
};
